export const getClientUrl = (path: string = "") =>
  `${process.env.NEXT_PUBLIC_CLIENT_URL}${path}`;

export const getClientApiProxyUrl = (path: string = "") =>
  `${process.env.NEXT_PUBLIC_CLIENT_URL}/api/proxy${path}`;
